var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { observer } from 'mobx-react';
import StackLayout from '../../../stackLayout/StackLayoutComponent';
import Icon from '../../../../advanced/icon/IconComponent';
import Text from '../../../../core/text/TextComponent';
var GridSectionHeader = function (_a) {
    var section = _a.section, sectionHeaderTheme = _a.sectionHeaderTheme;
    return (React.createElement(StackLayout, __assign({ horizontal: true, vCenter: true }, sectionHeaderTheme),
        section.icon ? React.createElement(Icon, { icon: section.icon, variationKey: sectionHeaderTheme.iconVariation, marginRight: true }) : null,
        React.createElement(Text, { variationKey: sectionHeaderTheme.titleTextVariation }, section.title)));
};
export default observer(GridSectionHeader);
//# sourceMappingURL=GridSectionHeader.js.map